<template>
  <div id="container">
    <div id="content">
      <h1>Group Email Templates</h1>
      <div>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" class="editor-container" label-position="top">
          <el-col :span="12">
            <el-form-item label="Category" prop="category">
              <el-select v-model="editForm.category" placeholder="Select" size="small">
                <el-option
                  v-for="item in categories"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Subcategory" prop="subcategory">
              <el-select v-model="editForm.subcategory" placeholder="Select" size="small">
                <el-option
                  v-for="item in subcategories"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-form-item label="Subject" prop="subject">
            <el-input v-model="editForm.subject" size="small"></el-input>
          </el-form-item>

          <el-form-item label="Body" prop="body">
            <el-input type="textarea" :autosize="{ minRows: 20, maxRows: 500}" :resize="vertical" cols="80"
                      v-model="editForm.body"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div id="preview">
        <p class="subject"><b>Subject:</b> {{editForm.subject}}</p>
        <div id="html-preview" v-html="html"></div>
      </div>
      <br clear="all">
      <template v-if="editForm.id">
        <el-button @click="onSave('editForm')" type="primary" icon="el-icon-document">Save</el-button>
        <el-button @click="onDelete">Delete</el-button>
      </template>
      <template v-else>
        <el-button @click="onSave('editForm')" type="primary" icon="el-icon-document">Create</el-button>
      </template>
    </div>
  </div>
</template>

<script>
  //import markdownEditor from 'components/markdowneditor.vue'

  import axios from 'axios'
  import showdown from 'showdown'
  const converter = new showdown.Converter()
  converter.setOption('simpleLineBreaks',true)
  //const content = '12345678901234567890123456789012345678901234567890123456789012345678901234567890'

  export default {
    metaInfo () {
      return {
        title: "Edit Email Template"
      }
    },

    components: {
      //markdownEditor//,
      //VueShowdown
    },
    data () {
      return {
        params: {},
        editForm: {
          id: '',
          category: '',
          subcategory: '',
          subject: '',
          body: '',
        },
        categories: [
          { value: 1, label: 'Student Templates' },
          { value: 2, label: 'Faculty Templates' },
          { value: 3, label: 'Note Taker/Proctor Templates' }
        ],
        subcategories: [
          { value: 1, label: 'Exam Accommodations' },
          { value: 2, label: 'Registration' },
          { value: 3, label: 'Accommodations-non-testing' },
          { value: 4, label: 'Other-miscellaneous' }
        ],
        rules: {
          category: [{ required: true, message: 'Please select a category', trigger: 'change' }],
          subcategory: [{ required: true, message: 'Please select a subcategory', trigger: 'change' }],
          subject: [{ required: true, message: 'Please enter a subject', trigger: 'blur' }],
          body: [{required: true, message: 'Please enter a message body', trigger: 'blur' }]
        }
      }
    },
    computed: {
      html () {
        return converter.makeHtml(this.editForm.body)
      }
    },
    methods: {
      displayError: function(msg) {
        this.$message({
          showClose: true,
          duration: 10000,
          type: 'error',
          message: msg,
          customClass: 'error-msg'
        });
      },
      markdown2Html: function() {
        //this.html = converter.makeHtml(this.content)
      },
      onDelete: function() {
        this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(response => {
          axios
            .delete('/api/group-email/email-template/?id=' + this.editForm.id)
            .then(function(response) {
              this.$router.push({ path: '/group-email/email-templates'});
            }).catch(function(error) {
            // eslint-disable-next-line
            console.log(error);
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      onSave: function(formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            if (this.editForm.id) { //updating
              axios
                .put('/api/group-email/email-template', {
                  id: +this.editForm.id,
                  category_id: this.editForm.category,
                  subcategory_id: this.editForm.subcategory,
                  subject: this.editForm.subject,
                  body: this.editForm.body
                })
                .then(response => {
                  this.$router.push({ path: '/group-email/email-templates', query: { id: this.editForm.id}});
                })
                .catch(function (error) {
                  // eslint-disable-next-line
                  console.log(error);
                });
            } else { //creating
              axios
                .post('/api/group-email/email-template', {
                  category_id: this.editForm.category,
                  subcategory_id: this.editForm.subcategory,
                  subject: this.editForm.subject,
                  body: this.editForm.body
                })
                .then(response => {
                  this.editForm.id = response.data.id;
                  this.$router.push({ path: '/group-email/email-templates', query: { id: this.editForm.id}});
                  //this.$message({
                  //   type: 'success',
                  //   message: 'Template saved'
                  //});
                })
                .catch(function (error) {
                  // eslint-disable-next-line
                  console.log(error);
                });

            }
          } else {
            // eslint-disable-next-line
            console.log('form not valid');
          }
        });
      },
      load: function () {
        this.params = this.$route.query;
        this.editForm.id = this.params.id;
        if(this.editForm.id) { //updating
          axios
            .get('/api/group-email/email-template/?id=' + this.editForm.id)
            .then(response => {
              // eslint-disable-next-line
              console.log(response);
              this.editForm.category = response.data.email_template_category_id;
              this.editForm.subcategory = response.data.email_template_sub_category_id;
              this.editForm.subject = response.data.subject;
              this.editForm.body = response.data.body;
            })
            .catch(error => {
              // eslint-disable-next-line
              console.log(error)
            });
        }
      }
    },
    mounted() {
      this.load()
    }
  }
</script>

<style lang="postcss" scoped>
  .error-msg p {
    color: red;
  }
  .editor-container {
    float: left;
  }
  .editor-container .CodeMirror {
    height: 100%!important;
  }
  .content {
    position: relative;
  }
  #html-preview h1, #html-preview h2, #html-preview h3 {
    color: black;
    border-bottom: none;
    padding: 0;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
  .el-form-item__content {
    line-height: 14px;
  }
  #html-preview {
    margin-left: 20px;
    padding-left: 10px;
    margin-top: 0;
    margin-bottom: 10px;
    background: #EBEFE5;
  }
  .subject {
    margin-left: 10px;
    padding-left: 10px;
  }
  #preview {
    width: 80ch;
    float: left;
    margin-top: 0px;
  }

</style>
